import { useState, useEffect } from 'react';
import { fetchAPI } from '../utils/api';

/**
 * Custom hook to fetch data from Strapi
 * @param {string} path - API endpoint path
 * @param {object} params - Query parameters
 * @returns {object} - { data, loading, error }
 */
const useStrapi = (path, params = {}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetchAPI(path, params);
                setData(response.data);
                setError(null);
            } catch (err) {
                console.error(`Error fetching ${path}:`, err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        if (path) {
            fetchData();
        }
    }, [path, JSON.stringify(params)]);

    return { data, loading, error };
};

export default useStrapi;
